import { Expense, Invoice } from '../types';
import { normalizePaymentType } from './paymentDisplay';

export function toISODate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function monthBounds(year: number, month: number): { start: string; end: string } {
  const start = new Date(year, month - 1, 1);
  const end = new Date(year, month, 0);
  return { start: toISODate(start), end: toISODate(end) };
}

export function invoiceInDateRange(inv: Invoice, startDate: string, endDate: string): boolean {
  const ts = inv.paymentTimestamp ? new Date(inv.paymentTimestamp).getTime() : NaN;
  if (!Number.isFinite(ts)) return false;
  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);
  const end = new Date(endDate);
  end.setHours(23, 59, 59, 999);
  return ts >= start.getTime() && ts <= end.getTime();
}

export function sumCollectionForPeriod(
  invoices: Invoice[],
  hostelId: number,
  startDate: string,
  endDate: string,
): number {
  return invoices
    .filter((inv) => {
      if (inv.isDeleted) return false;
      if (inv.hostelId != null && Number(inv.hostelId) !== hostelId) return false;
      if (!invoiceInDateRange(inv, startDate, endDate)) return false;
      if (normalizePaymentType(inv.paymentType) === 'REFUND') return false;
      return true;
    })
    .reduce((sum, inv) => sum + parseFloat(String(inv.paidAmount || 0)), 0);
}

export function sumExpensesForPeriod(expenses: Expense[], startDate: string, endDate: string): number {
  return expenses
    .filter((e) => {
      const raw = e.expenseDate || e.createdAt;
      if (!raw) return false;
      const t = new Date(raw).getTime();
      if (!Number.isFinite(t)) return false;
      const start = new Date(startDate);
      start.setHours(0, 0, 0, 0);
      const end = new Date(endDate);
      end.setHours(23, 59, 59, 999);
      return t >= start.getTime() && t <= end.getTime();
    })
    .reduce((sum, e) => sum + Number(e.amount || 0), 0);
}

export const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function buildYearOptions(fromYear = 2026): string[] {
  const y = Math.max(new Date().getFullYear(), fromYear);
  const years: string[] = [];
  for (let i = fromYear; i <= y + 1; i++) years.push(String(i));
  return years;
}
